import { render, staticRenderFns } from "./dimensionsDialog.vue?vue&type=template&id=2515d52a&scoped=true&"
import script from "./dimensionsDialog.vue?vue&type=script&lang=js&"
export * from "./dimensionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515d52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2515d52a')) {
      api.createRecord('2515d52a', component.options)
    } else {
      api.reload('2515d52a', component.options)
    }
    module.hot.accept("./dimensionsDialog.vue?vue&type=template&id=2515d52a&scoped=true&", function () {
      api.rerender('2515d52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FrontEndWarehouse/components/warehouseHome/dimensionsDialog.vue"
export default component.exports